'use strict';

angular.module('app')
    .service('check404', function ($http, $location, $rootScope, $timeout, Request, utils) {
        var check404 = {};

        check404.checkUrlStatus = function () {
            var url = $location.url();

            $rootScope.loader = true;
            $rootScope.code404 = false;
            $rootScope.code301 = false;
            $rootScope.code302 = false;

            return Request.get('check-url/', {url: url})
                .then(function(res) {
                    if (res.data.status === 301 || res.data.status === 302) {
                        var domain = $location.$$protocol + '://'+ $location.$$host;

                        $rootScope["code" + res.data.status] = true;
                        $rootScope.redirectedTo = domain + res.data.location;

                        $location.path(res.data.location);

                        return false;
                    }

                    if(res.data.status === 404) {
                        $rootScope.code404 = true;
                        $rootScope.notFound = true;
                    }

                    utils.hideLoader();
                    $rootScope.loader = false;

                    return res.data;
                }, function(err) {
                    if(err.status === 404) {
                        $rootScope.code404 = true;
                        $rootScope.loader = false;
                        utils.hideLoader();
                        return err;
                    }
                });
        };

        return check404;
    });
